import { Navbar, Main, Product, Footer, Category } from "../components";

function Home() {
  return (
    <>
      <Navbar />
      <Main /> 
      <Category />
      {/* <Product /> */}
      <Footer />
    </>
  )
}

export default Home